// src/components/nav/NavSidebar.jsx
import React from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import "./NavSidebar.css";

export default function NavSidebar({ open, onClose }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (to, external = false) => {
    onClose?.();
    if (external) window.open(to, "_blank", "noopener,noreferrer");
    else navigate(to);
  };

  const isActive = (testPath) =>
    pathname === testPath || pathname.startsWith(testPath);

  const mountNode =
    typeof document !== "undefined" ? document.body : null;
  if (!mountNode) return null;

  return createPortal(
    <>
      <div
        className={`ns-overlay ${open ? "ns-overlay--open" : ""}`}
        onClick={onClose}
        aria-hidden={!open}
      />

      <aside
        className={`ns-panel ${open ? "ns-panel--open" : ""}`}
        aria-hidden={!open}
      >
        <div className="ns-header">
          <span>Menu</span>
          <button
            className="ns-close"
            onClick={onClose}
            aria-label="Close sidebar"
          >
            ×
          </button>
        </div>

        <nav className="ns-list" role="navigation" aria-label="Primary">
          <button
            type="button"
            className={`ns-item ${
              isActive("/landing") ? "is-active" : ""
            }`}
            onClick={() => go("/landing")}
            aria-current={isActive("/landing") ? "page" : undefined}
          >
            <span className="ns-home">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 3.2 2.5 11a1 1 0 0 0 1.3 1.5l.7-.6V19a2 2 0 0 0 2 2h3.2a1 1 0 0 0 1-1v-4.6h3.8V20a1 1 0 0 0 1 1H20a2 2 0 0 0 2-2v-7.1l.5.4a1 1 0 1 0 1.3-1.6L12 3.2Z" />
              </svg>
              <span>Home</span>
            </span>
          </button>

          <button
            type="button"
            className="ns-item"
            onClick={() =>
              go("https://www.escortproject.eu/", true)
            }
          >
            Escort Project Site
          </button>
        </nav>
      </aside>
    </>,
    mountNode
  );
}